import { FileItem } from "types";

import { FileDropAreaWithFileList } from "../droparea";

type Props = {
    name: string;
    disabled?: boolean;
    maxUploadedFiles?: number;
    multiple?: boolean;
    onLoadFile?: (file: FileItem) => Promise<Partial<FileItem>>;
    onDeleteFile?: (file: FileItem) => Promise<void>;
};

export default function HookFormFileDropAreaWithFileList({ name, disabled, maxUploadedFiles, multiple, onLoadFile, onDeleteFile }: Props) {
    return (
        <FileDropAreaWithFileList
            name={name}
            disabled={disabled}
            maxUploadedFiles={maxUploadedFiles}
            multiple={multiple}
            onLoadFile={onLoadFile}
            onDeleteFile={onDeleteFile}
        />
    );
}
